export default "__VITE_ASSET__d42Vym0Z__"